<p-confirmDialog key="edit" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Grid-->
<div class="MainGrid2Col">
	<label>Adding Attendance Excuse to:</label>
	<label class="InfoText">{{ SchoolNameText }}</label>

	<label>Code:</label>
	<input class="form-control" type="text" placeholder="Excuse code/abbreviation" [(ngModel)]="Code" />

	<label>Description:</label>
	<input class="form-control" type="text" placeholder="Excuse name/description" [(ngModel)]="Desc" />

	<label>Excused?</label>
	<input class="form-control" style="margin-top: 0px" type="checkbox" [(ngModel)]="Excused" />

	<label>Excuse counts as present in school?</label>
	<input class="form-control" style="margin-top: 0px" type="checkbox" [(ngModel)]="CountPresent" />

	<label>Available to all schools?</label>
	<input
		[disabled]="UserNotDistrictLevel() == true"
		class="form-control"
		style="margin-top: 0px"
		type="checkbox"
		(ngModelChange)="onAllChange($event)"
		[(ngModel)]="AllSchools"
	/>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onUpdate()">Update Excuse</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
